<template>
  <pt-video-review class="pt-video-review__page"></pt-video-review>
</template>

<script>
import PtVideoReview from 'cps/tool-operation/pt-video-review/withData'
export default {
  name: 'pt-video-review__view',
  components: {
    'pt-video-review': PtVideoReview
  }
}
</script>
